import type {CampaignId} from "home/landing/campaignPlayback";

export const LANDING_VIEW_FRACTION = .5;
export const LANDING_VIEW_DWELL_MS = 2000;

/** Continuous visibility, not a sum of short glimpses. Interruption discards elapsed dwell. */
export class LandingDwell {
	private slide: CampaignId | null = null;
	private since: number | null = null;
	observe(slide: CampaignId, now: number, ratio: number, unobscured: boolean): boolean {
		if (slide !== this.slide || !unobscured || ratio < LANDING_VIEW_FRACTION) {
			this.slide = slide;
			this.since = null;
		}
		if (!unobscured || ratio < LANDING_VIEW_FRACTION) return false;
		this.since ??= now;
		return now - this.since >= LANDING_VIEW_DWELL_MS;
	}
}
